import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Obserwujący',
  steps: {
    upload: 'Prześlij',
    validate: 'Potwierdź',
    finish: 'Gotowe',
  },
  labels: {
    import: 'Import',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
